import * as React from "react";
import { forwardRef } from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.2132 6.61522L6.41421 26.4142L5 25L24.799 5.20101L26.2132 6.61522Z", fill: "#555A5F" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.3848 26.2132L4.58579 6.41421L6 5L25.799 24.799L24.3848 26.2132Z", fill: "#555A5F" }));
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
